import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';

class Logo extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    render() {
        const {
            content: { logo = {}, domain, breadCrumbdata = [], locale = {} },
        } = this.props;
        const sep = locale.breadcrumbSep || ' > ';
        const current = locale.breadcrumbCurrent || '';
        const map = locale.breadcrumbMap || {};
        const textOf = (title) => map[title] || title;

        return (
            <div className={styles.logo}>
                {logo.logo ? (
                    <a className={styles.logoLink} href={`//${domain}`} target="_blank" rel="noreferrer">
                        <img src={logo.logo} alt={logo.title || ''} />
                    </a>
                ) : null}
                <div className={styles.breadcrumbs}>
                    {(breadCrumbdata || []).map((item, index) => (
                        <span key={index}>
                            <a href={item.url}>{textOf(item.title)}</a>
                            {sep}
                        </span>
                    ))}
                    {current ? <span>{current}</span> : null}
                </div>
            </div>
        );
    }
}

export default errorBoundary(Logo);
